import React from 'react';
import { CheckIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { finalIncludes, productName } from '../data/content';
import { CtaButton } from './CtaButton';
import { ProductCollage } from './ProductCollage';
import { BonusFan } from './BonusFan';
import { SunRays } from './decor/SunRays';
export function FinalOffer() {
  return <section id="offer" aria-labelledby="offer-title" className="relative overflow-hidden bg-cream-deep" data-id="element-87" data-mp="1cdijqwv7n8qe">
      <SunRays className="pointer-events-none absolute -right-40 -top-40 w-[560px] text-gold/20" data-id="element-88" data-mp="1qcqjprz76kvn" />
      <div className="relative mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-89" data-mp="1lf8di9ckejrc">
        <div className="mx-auto max-w-3xl text-center" data-id="element-90" data-mp="203v2l2rzupvr">
          <h2 id="offer-title" className="text-balance font-display text-[40px] leading-[1.04] text-navy sm:text-[58px]" data-id="element-91" data-mp="1v4rv7bojk7km">
            Start Sharing the Gospel With Confidence Today
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-lg leading-relaxed text-ink-soft" data-id="element-92" data-mp="2469gd8gt2zg6">
            Here’s everything you get — a complete Gospel-sharing library, ready whenever an opportunity comes.
          </p>
        </div>

        <div className="mt-14 space-y-6" data-id="element-93" data-mp="6pl49ghazjw9">
          <ProductCollage data-id="element-94" data-mp="6qd1swugnrp6" />
          <BonusFan data-id="element-95" data-mp="bnwhm16t4cj8" />
        </div>

        <div className="mx-auto mt-12 grid max-w-4xl overflow-hidden rounded-3xl bg-white shadow-sheet ring-2 ring-coral/25 md:grid-cols-[1fr_1.1fr]" data-id="element-96" data-mp="bmtrhvhb6e4d">
          <div className="p-7 sm:p-9" data-id="element-97" data-mp="kob5n8b5o5qf">
            <p className="text-xs font-extrabold uppercase tracking-[0.14em] text-coral-deep" data-id="element-98" data-mp="knjhujnsvcap">Complete bundle</p>
            <h3 className="mt-2 font-display text-3xl leading-tight text-navy" data-id="element-99" data-mp="pltfd0wzyozh">{productName}</h3>
            <ul className="mt-6 space-y-3" data-id="element-100" data-mp="uemjbmkn5tai">
              {finalIncludes.map(item => <li key={item} className="flex items-center gap-3 font-bold text-navy" data-id="element-101" data-mp="zbw60ugnbqun">
                  <CheckIcon className="h-5 w-5 shrink-0 text-leaf-deep" strokeWidth={3} aria-hidden="true" data-id="element-102" data-mp="14dboqfvcpl9v" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="flex flex-col justify-center bg-cream p-7 text-center sm:p-9" data-id="element-103" data-mp="35fkxj9fjh5lb">
            <p className="text-ink-mute" data-id="element-104" data-mp="30g85895wf6bc">
              Regular value <span className="font-bold line-through decoration-coral decoration-2" data-id="element-105" data-mp="30dlw453d0ir0">$69</span>
            </p>
            <p className="mt-1 flex items-end justify-center gap-3" data-id="element-106" data-mp="39g4twasag56e">
              <span className="pb-3 text-sm font-extrabold uppercase tracking-[0.14em] text-navy" data-id="element-107" data-mp="39etq4ayuexfa">Today</span>
              <span className="font-display text-[88px] leading-[0.9] text-coral" data-id="element-108" data-mp="3o6uaxtsfkei6">$27</span>
            </p>
            <CtaButton checkout block className="mt-6" data-id="element-109" data-mp="3j8aqjxthjarx">
              Get Access Now
            </CtaButton>
            <div className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm font-semibold text-ink-soft" data-id="element-110" data-mp="3t445toyl9ide">
              <span className="inline-flex items-center gap-1.5" data-id="element-111" data-mp="22spvav0i3y5r">
                <ZapIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-112" data-mp="1yq31wpo6m56g" />
                Instant Digital Access
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-113" data-mp="1on7ijrgkuh35">
                <ShieldCheckIcon className="h-4 w-4 text-leaf-deep" aria-hidden="true" data-id="element-114" data-mp="1snhvxp6p89s1" />
                7-Day Guarantee
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}